// extracted by css-extract-rspack-plugin
export default {"small":"BnU8G","large":"U4EBR"};